import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M8.288 15.045a5.25 5.25 0 0 1 7.424 0M5.106 11.863c3.807-3.808 9.98-3.808 13.788 0M1.924 8.68c5.565-5.565 14.587-5.565 20.152 0m-9.546 9.546-.53.53-.53-.53a.75.75 0 0 1 1.06 0"
    }, null, -1)
  ])))
}
export default { render: render }